module.exports = __webpack_public_path__ + "img/membership-activated-female.ceb7fce.png";